export const tokens = {
  defaultRadius: "lg",
  // #region colors
  colors: {
    primary: [
      "#ede7f6", // 0
      "#d1c4e9", // 1
      "#b39ddb", // 2
      "#9575cd", // 3
      "#7e57c2", // 4
      "#673ab7", // 5 <-- your main primary
      "#5e35b1", // 6
      "#512da8", // 7
      "#4527a0", // 8
      "#311b92", // 9
    ],
    secondary: [
      "#f0ebf9", // 0 lightest
      "#dfd3f2", // 1
      "#cbb9ea", // 2
      "#b49fe1", // 3
      "#9f85d8", // 4
      "#9575cd", // 5 main
      "#8761b9", // 6
      "#764da6", // 7
      "#643b91", // 8
      "#4f2a78", // 9 darkest
    ],
    accent: [
      "#f9e6fc", // 0 lightest
      "#f3c9fa", // 1
      "#ecaae1", // 2
      "#e68adb", // 3
      "#df6ad3", // 4
      "#e040fb", // 5 main
      "#c437d9", // 6
      "#a82fc0", // 7
      "#86269f", // 8
      "#641a7c", // 9 darkest
    ],
    blue: [
      "#e1f8ff", // 0
      "#cbedff", // 1
      "#9ad7ff", // 2
      "#64c1ff", // 3
      "#3aaefe", // 4
      "#20a2fe", // 5 <-- your main primary
      "#099cff", // 6
      "#0088e4", // 7
      "#0079cd", // 8
      "#0068b6", // 9
    ],
    red: [
      "#ffeaea", // 0
      "#fed4d4", // 1
      "#f5a6a8", // 2
      "#ed7678", // 3
      "#e74e50", // 4
      "#e43436", // 5 <-- your main primary
      "#e32629", // 6
      "#ca181c", // 7
      "#b51017", // 8
      "#9e0111", // 9
    ],
    lightColor: [
      "#ffffff", // 0 main white
      "#fefefe", // 1
      "#F8F9FA", // 2
      "#E9ECEF", // 3
      "#DEE2E6", // 4
      "#CED4DA", // 5
      "#ADB5BD", // 6
      "#6C757D", // 7
      "#495057", // 8
      "#343A40", // 9 darkest
    ],
    darkColor: [
      "#6C757D", // 0  lightest
      "#5A6268", // 1
      "#495057", // 2
      "#3E444A", // 3
      "#343A40", // 4
      "#2C3136", // 5
      "#25292D", // 6
      "#212529", // 7
      "#1A1D20", // 8
      "#141619", // 9 darkest
    ],
  },

  shadows: {
    md: "1px 1px 3px rgba(0, 0, 0, .25)",
    xl: "5px 5px 3px rgba(0, 0, 0, .25)",
  },

  headings: {
    fontFamily: "Roboto, sans-serif",
    sizes: {
      h1: { fontSize: 36 },
    },
  },
};

export default tokens;
